import { useEffect, useMemo, useRef } from "react";
import type { PlanFieldItem } from "../../../../BookingForm/components/Commercial/add-plan";
import { useBookingSelector } from "../../../../BookingForm/hooks/useBookingSelector";
import { buildPlansFromBookingDetails } from "./buildPlansFromBookingDetails";
import { useTorRules } from "../../../../BookingForm/hooks/useTorRules";

type UseHydratePaymentPlansProps = {
  paymentPlansInvalidated: boolean;
  replace: (plans: PlanFieldItem[]) => void;
};

export const useHydratePaymentPlans = (props: UseHydratePaymentPlansProps) => {
  const { paymentPlansInvalidated, replace } = props;
  const bookingDetails = useBookingSelector();
  const { isTurnoverRentOnly } = useTorRules();
  const hydratedLeaseIdRef = useRef<string | null>(null);

  const plans = useMemo(
    () => buildPlansFromBookingDetails(bookingDetails, isTurnoverRentOnly),
    [bookingDetails, isTurnoverRentOnly],
  );

  useEffect(() => {
    const leaseId = bookingDetails?.leaseId;
    if (!leaseId || bookingDetails.isLoadingBookingDetails) return;
    // Leave empty defaultValues; do not replace(plans) with stale API data.
    if (paymentPlansInvalidated) return;
    if (hydratedLeaseIdRef.current === leaseId) return;

    hydratedLeaseIdRef.current = leaseId;
    replace(plans);
  }, [bookingDetails?.leaseId, bookingDetails.isLoadingBookingDetails, paymentPlansInvalidated, plans, replace]);
};
